
<template>
  <div class="drivers-engagement-wrap box-container">
    <div class="card-title">
      <span v-if="activeSubdriver">{{activeSubdriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span>
      <span v-else>{{activeDriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span>
      score
    </div>
    <div class="card-score"
      v-if="driverData.engagement_stats
      && driverData.engagement_stats.engagement_score"
    >
      <span class="main-score"
        v-if="driverData.engagement_stats
        && driverData.engagement_stats.engagement_score"
      >
        {{driverData.engagement_stats.engagement_score.toFixed(1)}}
      </span>
      <span class="main-score" v-else>0</span>
      <span class="score-sub">/5</span>
    </div>
    <div class="card-score am-no-data" v-else>
      {{amNoData}}
    </div>
    <div id="driver-participation" class="driver-participation-chart">
    </div>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs-ext/plugin/customParseFormat';

import { AM_NODATA } from '../../../constant';

import DriversMixin from '../drivers-mixins';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
am4core.useTheme(am4themes_animated);

export default {
  name: 'DriversEngagement',

  mixins: [DriversMixin],

  props: {
    activeDriver: {
      required: true,
      type: String
    },
    activeSubdriver: {
      required: true,
      type: String
    }
  },

  watch: {
    driverData: {
      deep: true,
      // immediate: true,
      handler () {
        if (this.driverData && this.driverData.engagement_stats && this.driverData.engagement_stats.monthwise_enagagement_stats) {
          this.driverParticipationChart();
        }
      }
    }
  },

  mounted () {
    if (this.driverData && this.driverData.engagement_stats && this.driverData.engagement_stats.monthwise_enagagement_stats) {
      this.driverParticipationChart();
    }
  },

  computed: {
    amNoData () {
      return AM_NODATA;
    }
  },

  // mounted () {
  //   this.driverParticipationChart();
  // },

  methods: {
    driverParticipationChart () {
      const formattedData = [];
      this.$lodash.each(this.driverData.engagement_stats.monthwise_enagagement_stats, (v) => {
        formattedData.push({
          month: dayjs(v.month).format('MMM \'YY'),
          value: v.engagement_stats.month_driver_average
        });
      });
      // console.log('formattedData', formattedData);
      // Create chart instance
      var chart = am4core.create('driver-participation', am4charts.XYChart);
      // Add data
      chart.data = formattedData;
      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'month';
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.renderer.grid.template.location = 0.5;
      categoryAxis.startLocation = 0.5;
      categoryAxis.endLocation = 0.5;
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.tooltip.disabled = true;
      categoryAxis.renderer.labels.template.disabled = true;
      // Create value axis
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.baseValue = 0;
      valueAxis.fontSize = 12;
      valueAxis.min = 0;
      valueAxis.max = 5;
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.labels.template.disabled = true;
      valueAxis.tooltip.disabled = true;
      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = 'value';
      series.dataFields.categoryX = 'month';
      series.strokeWidth = 2;
      series.tensionX = 0.77;
      series.fillOpacity = 0.8;
      series.stroke = '#050550';
      series.fill = '#050550';
      var bullet1 = series.bullets.push(new am4charts.CircleBullet());
      series.heatRules.push({
        target: bullet1.circle,
        min: 5,
        max: 10,
        property: 'radius'
      });
      bullet1.tooltipText = '{categoryX}: {valueY}';
      chart.cursor = new am4charts.XYCursor();
    }
  }
};
</script>

<style lang="scss" scoped>
.drivers-engagement-wrap {
  // padding: 16px;
  // background-color: var(--bg);
  height: 15rem;
  .am-no-data {
    height: 12rem;
  }
  .card-title {
    padding: 16px 2px 0 2px;
    word-spacing: 1px;
    text-align: center;
    font-size: var(--content-size);
    font-size: 15px;
    color: var(--color-text);
  }
  .card-score {
    text-align: center;
    // line-height: 1;
    .main-score {
      color: var(--color-text);
      font-size: 4rem;
    }
    .score-sub {
      color: var(--color-text);
      font-size: 2rem;
      margin-left: -12px;
    }
  }
  .driver-participation-chart {
    margin-top: -42px;
    margin-left: -16px;
    margin-right: -16px;
    height: 160px;
  }
  .driver-participation {
    height: 200px;
    padding: 16px;
    border-radius: 12px;
    box-shadow: 0 4px 20px 1px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.08) !important;
    // box-shadow: 26px 16px 36px 0 rgba(0, 0, 0, 0.01) inset !important
    .participation-title {
      font-size: 16px;
      font-weight: 600;
      color: var(--primary-dark);
      text-align: center;
    }
    .participation-score {
      font-size: 3.5rem;
      text-align: center;
      font-weight: 400;
      // line-height: 1;
      // color: var(--primary-dark);
    }
  }
}
</style>
